if (typeof Shopify === 'undefined') {
  Shopify = {};
}
let currentVariantId;
Shopify.queue = [];

Shopify.moveAlong = function() {
  // If we still have requests in the queue, let's process the next one.
  if ( Shopify.queue.length ) {
    var request = Shopify.queue.shift();
    Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);

  }
  else {
    $("#ajax-overlay").hide();
    $("#ajax-progress").hide();
    document.location.href = '/cart';
  }
};

Shopify.addItem = function(id, qty, properties, callback) {

  if ( id == undefined ) {

    return;

  }

  var params = {
    quantity: qty,
    id: id
  };

  if(properties != false){

    params.properties = properties;

  }

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: params,
    dataType: "json"
  })
    .done(function(t) {
      "function" == typeof e ? e(t) : Shopify.onItemAdded(t)
    })
    .always(function(t) {
      Shopify.moveAlong();
    })
    .fail(function(t, r) {
      alert( "error" );
      Shopify.onError(t, r);
    });

};

// Get from cart.js returns the cart in JSON
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart, textStatus);
    } else {
      return cart;
    }
  });
};

Shopify.onUpdateCount = function(cart) {
  let icoCount = $('.topping__ico-amount');
  let item_count = cart.item_count;
  if (icoCount.length == 0) {
    $('.topping__cart').append('<span class="topping__ico-amount">' + item_count + '</span>');
  } else {
    $('.topping__ico-amount').text(item_count);
  }
  if ($('body').hasClass('template-product')) {
    hideProgress();
  }
};

Shopify.onItemAdded = function(t, f) {
  if(t.variant_options[0] != "Default Title" ){
    var prodId = t.product_id + "-" + t.id;
  }else{
    var prodId = t.product_id;
  }
  gtag('event', 'add_to_cart', {
    'value': t.price * 0.01,
    'items': [
      {
        'id': prodId,
        'google_business_vertical': 'retail'
      }
    ]
  });
  Shopify.getCart(Shopify.onUpdateCount);
  if (jQuery(f).length > 0) {
    let addToCart = jQuery(f).find('[type="submit"]');
    let addToCartSectId = addToCart.attr("data-section-id");
    setTimeout(function() {
      var submitText = jQuery(f).find('#preOrderInput').attr('name') == 'properties[Type]' ? theme.strings.preOrder : theme.strings.addToCart;
      addToCart.html('<span id="AddToCartText-' + addToCartSectId + '">' + submitText + '</span>').removeClass('added');
    }, 2000);
  }
};

Shopify.onError = function(XMLHttpRequest) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

Shopify.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      jQuery(form).find('[type="submit"]').html('<span class="preloader">Added to cart</span>').addClass('added');
      if (typeof callback === 'function') {
        callback(line_item, form);
      } else {
        Shopify.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if (typeof errorCallback === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', 'noopener');
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

var currentVariant = false;

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    currentVariant = this._getVariantFromOptions();


    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );

    const unitArr = document.querySelectorAll('.myUnitbtn');
    const masterSelect = document.getElementById('SingleOptionSelector-0');
    const secondSelect = document.getElementById('SingleOptionSelector-1');
    const thirdSelect = document.getElementById('SingleOptionSelector-2');
    if (unitArr.length > 0) {
      unitArr.forEach(unit => {
        
        unit.addEventListener('click', (e) => {
          unitArr.forEach(el=>{
            el.classList.remove('selected');
          })
          unit.classList.add('selected');
          this.currentVariant = this._onMyUnitSelect(unit);
          currentVariant = this._onMyUnitSelect(unit);

          masterSelect.selectedIndex = "0";
          secondSelect.selectedIndex = "0";
          thirdSelect.selectedIndex = "0";
        });
      });
    }
    
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
      return found;
    },

    _onMyUnitSelect: function(unit) {
      let vId = +unit.dataset.variantid;
      var variants = this.product.variants;
      let variant = variants.find(function(variant){ return variant.id == vId });

        currentVariant = variant;

        
        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });
        this.currentVariant = variant;
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        this._updateVariantId(variant);
        this._updateQuote(variant);
        
        
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
    },



    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function(evt) {

      if(evt.target.id == 'SingleOptionSelector-0' && evt.target.value != ''){
        $('#SingleOptionSelector-1').html(this._getSelectHtml( evt.target.value, 1 ));
        $('#SingleOptionSelector-1').prop('disabled', false);
      }
      else if(evt.target.id == 'SingleOptionSelector-0' && evt.target.value == ''){
        $('#SingleOptionSelector-1').html(this._getSelectHtml( evt.target.value, 1 ));
        $('#SingleOptionSelector-2').html(this._getSelectHtml( evt.target.value, 2, $('#SingleOptionSelector-0').val(), ''));
        $('#SingleOptionSelector-1').prop('disabled', true);
        $('#SingleOptionSelector-2').prop('disabled', true);
        $('#Force_Select').val('').prop('disabled', true);
      }

      if(evt.target.id == 'SingleOptionSelector-1' && evt.target.value != ''){
        $('#SingleOptionSelector-2').html(this._getSelectHtml( evt.target.value, 2, $('#SingleOptionSelector-0').val() ));
        $('#SingleOptionSelector-2').prop('disabled', false);
        $('#Force_Select').prop('disabled', false);
      }
      else if(evt.target.id == 'SingleOptionSelector-1' && evt.target.value == ''){
        $('#SingleOptionSelector-2').html(this._getSelectHtml( evt.target.value, 2, $('#SingleOptionSelector-0').val(), ''));
        $('#Force_Select').val('').prop('disabled', true);
      }


      var variant = this._getVariantFromOptions();
      currentVariant = variant;

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {

        if(evt.target.id == 'SingleOptionSelector-0' && $('#SingleOptionSelector-1 option').length == 2) {
          $('#SingleOptionSelector-1 option:eq(1)').prop("selected", true);
          $('#SingleOptionSelector-1').trigger('change');
        }

        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateVariantId(variant);
      this.currentVariant = variant;
      
      //console.log('!!! variant',variant)

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      const unitArr = document.querySelectorAll('.myUnitbtn');
      unitArr.forEach(el=>{
        el.classList.remove('selected');
      })

    },

    _getSelectHtml: function(selected, option, option1_value, option2_value){
      var variants = this.product.variants;
      var selectHtml = "";
      var optionCount = 0;
      var option_name = $('#SingleOptionSelector-'+ option ).data("label");
      for (var k in variants){
        if(option == 1 && variants[k].option1 == selected){
          optionCount++;
          var include_string = ">" + variants[k].option2 + "<";
          if(!selectHtml.includes(include_string)){
            if($('#SingleOptionSelector-1').val() == variants[k].option2){
              selectHtml += "<option value='"+ variants[k].option2 + "' selected>" + variants[k].option2 + "</option>";
            }
            else{
              selectHtml += "<option value='"+ variants[k].option2 + "'>" + variants[k].option2 + "</option>";
            }
          }
        }
        else if(option == 2 && option1_value == variants[k].option1 && variants[k].option2 == selected){
          optionCount++;
          if($('#SingleOptionSelector-2').val() == variants[k].option3){
            selectHtml += "<option value='"+ variants[k].option3 + "' selected>" + variants[k].option3 + "</option>";
          }
          else{
            selectHtml += "<option value='"+ variants[k].option3 + "'>" + variants[k].option3 + "</option>";
          }
        }
        else if(option == 2 && selected == '' && variants[k].option1 == option1_value){
          optionCount++;
          selectHtml += "<option value='"+ variants[k].option3 + "'>" + variants[k].option3 + "</option>";
        }
      }
      if(option == 1){
        selectHtml = "<option value=''>Select "+ option_name +"</option>" + selectHtml;
      }
      else if(option == 2 && (optionCount > 1 || optionCount == 0)){
        selectHtml = "<option value=''>Select "+ option_name +"</option>" + selectHtml;
      }

      if(option == 2 && $('select#Force_Select').length > 0){
        $('select#Force_Select > option').each(function(){
          if($(this).attr("value") != ''){
            $('select#Force_Select').val($(this).val());
            return;
          }
        });
      }
      return selectHtml;
    },

    _updateTagVariant: function(evt) {
      var option3_value = $('#SingleOptionSelector-2').val();
      var tagVariantElem = $('#SingleOptionSelector-2').closest('.col-4').next('.col-4').find('select[name*="properties"]');
      var sku = $(this.originalSelectorId).find('option:selected').attr("data-sku");
      if(tagVariantElem){
        tagVariantElem.find('option').css("display", "block");
        tagVariantElem.find('option:eq(0)').prop('selected', true);
        tagVariantElem.prop('disabled', true);
        if(option3_value != ''){
          tagVariantElem.prop('disabled', false);
          if(tagVariantElem.find('option[value]').length == 1){
            tagVariantElem.find('option:eq(0)').css("display", "none");
            tagVariantElem.find('option:eq(1)').prop('selected', true);
          }
          else{
            tagVariantElem.find('option[data-variant-sku]').each(function(){
              if($(this).attr("data-variant-sku").includes("_" + sku +"_")){
                $(this).css("display", "block");
              }
              else{
                $(this).css("display", "none");
              }
            });
            tagVariantElem.find('option:eq(0)').css("display", "none");
            tagVariantElem.find('option[data-variant-sku*="'+ sku +'_"]').prop('selected', true);
          }
        }
        else{
          tagVariantElem.find('option:eq(0)').prop('selected', true);
          tagVariantElem.prop('disabled', true);
        }
      }
      //$('[data-specs-force]').text($('#Force_Select').val() ? $('#Force_Select').val() : $('.single-option-selector[data-label="Force"]').val());
      //$('[data-specs-speed]').text($('#Speed_Select').val() ? $('#Speed_Select').val() : $('.single-option-selector[data-label="Speed"]').val());
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      var sku = $('.catalog-item__info-model .variant-sku').text();
      if (sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },
    _updateVariantId: function(variant) {
      var id = $('.variant-id').text();
      if (id === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantIDChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      //console.log('_updateHistoryState',variant);
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
      this._updateTagVariant();
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    multicurrencySelector: '[data-currency-selector]',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.topping__nav-item--drop',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.topping__nav-name',
    siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on('mouseenter.siteNav', function() {
      var $el = $(this);

      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('mouseleave.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });

    $(selectors.multicurrencySelector).on('change', function() {
      $(this)
        .parents('form')
        .submit();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight();

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)'
    });

    cache.$pageContainer.css({
      transform:
        'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr('aria-expanded', true);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)'
    });

    cache.$pageContainer.removeAttr('style');

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body')
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr('aria-expanded', false)
      .focus();

    $(window).off('keyup.mobileNav');

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    /* if going back to first subnav, focus is on whole header */
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

    var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    searchResultSubmit: '#SearchResultSubmit',
    searchResultInput: '#SearchInput',
    searchResultMessage: '[data-search-error-message]',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    hidden: 'hide',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    initDrawer();

    var isSearchPage =
      slate.utils.getParameterByName('q') !== null &&
      window.location.pathname === '/search';

    if (isSearchPage) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on(
      'click',
      validateSearchResultForm.bind(this)
    );

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function() {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false')
      .attr('aria-haspopup', 'dialog');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
      .removeAttr('aria-describedby')
      .removeAttr('aria-invalid');
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
      .attr('aria-describedby', 'error-search-form')
      .attr('aria-invalid', true);
  }

  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0
        }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2
        }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.focus();
  }

  return {
    init: init
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
    $('#forms_wrapper').addClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      //$newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      //$('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle',
    inputQty: '.cart__qty-input',
    thumbnails: '.cart__image',
    item: '.cart__row'
  };

  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);
    this.$inputQuantities = $(selectors.inputQty, this.$container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick);
    this.$inputQuantities.on('change', this._handleInputQty);

    this.$thumbnails.css('cursor', 'pointer');
    this.$thumbnails.on('click', this._handleThumbnailClick);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));
      var isExpanded = $evtTarget.attr('aria-expanded') === 'true';

      $evtTarget
        .toggleClass(config.showEditClass)
        .attr('aria-expanded', !isExpanded);
      $updateLine.toggleClass(config.showClass);
    },

    _handleInputQty: function(evt) {
      var $input = $(evt.target);
      var value = $input.val();
      var itemKey = $input.data('quantity-item');
      var $itemQtyInputs = $('[data-quantity-item=' + itemKey + ']');
      $itemQtyInputs.val(value);
    },

    _handleThumbnailClick: function(evt) {
      var url = $(evt.target).data('item-url');

      window.location.href = url;
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  };

  var constants = {
    SORT_BY: 'sort_by'
  };

  var selectors = {
    mainContent: '#MainContent',
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    defaultSort: '#DefaultSortBy'
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
    this._initBreakpoints();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function() {
      var self = this;

      enquire.register(settings.mediaQueryMediumUp, {
        match: function() {
          self._resizeSelect(self.$selects);
        }
      });
    },

    _onSortChange: function() {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, '');
      var queryStringValue = slate.utils.getParameterByName('q');
      var query = queryStringValue !== null ? queryStringValue : '';

      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, '');
        query = query !== '' ? '?q=' + query + '&' : '?';

        window.location.href =
          urlStripped + query + sort + selectors.mainContent;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url;
      }
    },

    _onFilterChange: function() {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : '';

      document.location.href = filter + search + selectors.mainContent;
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();

    let $window = $(window);
    let header = $('#shopify-section-header').find('.site-header');
    let headerSticky = header.find('.topping__line-bottom');
    let header_offset = headerSticky.offset().top;

    function stickyHeader() {
      if (header.hasClass('with-sticky')) {
        if(header_offset <= $(window).scrollTop()){
          header.addClass('fixed');
        } else {
          header.removeClass('fixed');
        }
      }
    }

    $window.on('scroll', function () {
      stickyHeader();
    });

    var dwidth = $(window).width();
    $window.on('resize', function () {
      var wwidth = $(window).width();
      if(dwidth!==wwidth){
        header_offset = header.height();
        stickyHeader();
      }
    });
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
      classes.errorMsg +
      '">' +
      theme.strings.authError +
      '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                classes.errorMsg +
                '">' +
                errorMessage +
                '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

var currentVariantPrice = 0;

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryTabletPortrait: 'screen and (min-width: 768px) and (max-width: 1366px) and (orientation:landscape)',
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: true,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      errorQuantityMessage: '#error-quantity-' + sectionId,
      quantity: '#Quantity-' + sectionId,
      SKU: '.variant-sku',
      variant_id: '.variant-id',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productFeaturedImage: '.product-featured-img',
      productFeaturedWrapper: '.product__featured-wrapper',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      stockLabel: '.catalog-item__abs-block',
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      specsTableWithSlider: '.catalog-info__table-tag',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      inventoryHtml: '.inventoryWrapper'
    };

    this.classes = {
      hidden: 'hide',
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable'
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor

    // if (!$('#ProductJson-' + sectionId).html()) {
    //   return;
    // }
    // this.productSingleObject = JSON.parse(
    //   document.getElementById('ProductJson-' + sectionId).innerHTML
    // );

    if (!window.productSingleObject) {
      return;
    }
    this.productSingleObject = window.productSingleObject;

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
    this._updateQuote(currentVariantPrice);

    if ($(this.selectors.specsTableWithSlider).length > 1) {
      this._initSpecsTableWithSlider();
    }

    var windWidth = $(window).width();
    var orientation = (window.screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;
    if (windWidth <= 768 && (window.innerHeight > window.innerWidth)) {
      this._initThumbnailSlider();
      this._initFeaturedSlider();
      $('.tabs__button--active').removeClass('tabs__button--active');
      $('.tabs__button-mob').addClass('tabs__button--active');
    }

    if (windWidth == 1024 && (window.innerHeight > window.innerWidth)) {
      this._initFeaturedSlider();
    }
    if (windWidth >= 1367 || windWidth == 1024 && (window.innerHeight > window.innerWidth)) {
      this._initThumbnailSlider();
    }

    $(this.selectors.addToCart).closest('form').on('submit', function(evt) {
      evt.preventDefault();
      showProgress();
      Shopify.addItemFromForm(evt.target);
    });
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initSpecsTableWithSlider: function() {
      var hidden = 'swipe-hidden';
      var swipeRight = '.swipe-right';
      var swipeLeft = '.swipe-left';

      $(this.selectors.specsTableWithSlider).each(function() {
        var $el = $(this);
        var $table = $el.find('table');
        var $tr = $table.find('tr');
        var $swipeBar = $el.find('.swiper-bar ul');
        var $tdL = $tr.eq(0).find('td').length;
        $table.attr('data-count', $tdL);
        if ($tdL > 3) {
          for (var i = 0; i < $tdL; i++) {
            $tr.find('td:nth-child(n + 4)').addClass(hidden);
            $swipeBar.append('<li class="' + (i > 2 ? hidden : '') + '"><i></i></li>');
          }
          $el.find('.swiper-bar').removeClass('hide');
        }
      });

      function swipeRows($arrow, current, next, hide, max) {
        var $el = $arrow.parent();
        var $swipeBar = $arrow.parent().find('.swiper-dots');
        var $tr = $arrow.parent().prev().find('tr');

        var nthHidden = ':nth-child(' + hide + ')';
        var nthShow = ':nth-child(' + current + ')';
        $el.find($arrow.hasClass('swipe-right') ? swipeLeft : swipeRight).removeClass(hidden).attr('data-step', hide);

        $tr.find('td' + nthHidden).addClass(hidden);
        $tr.find('td' + nthShow).removeClass(hidden);
        $swipeBar.find('li' + nthHidden).addClass(hidden);
        $swipeBar.find('li' + nthShow).removeClass(hidden);
        if (max == current) {
          $arrow.addClass(hidden);
        } else {
          $arrow.attr('data-step', next);
        }
      }

      $(this.selectors.specsTableWithSlider).on('click', swipeLeft, function(e) {
        e.preventDefault();
        var $arrow = $(this);
        var current = parseInt($arrow.attr('data-step'));
        swipeRows($arrow, current, (current - 1), (current + 2), 2);
      });

      $(this.selectors.specsTableWithSlider).on('click', swipeRight, function(e) {
        e.preventDefault();
        var $arrow = $(this);
        var current = parseInt($arrow.attr('data-step'));
        var $tdL = $arrow.parent().prev().find('tr').eq(0).find('td').length;
        swipeRows($arrow, current, (current + 1), (current - 2), $tdL);
      });
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQueryTabletPortrait, {
        match: function() {
          self._destroyThumbnailSlider();
          self._initThumbnailSlider();

          if (self.settings.sliderMobileActive) {
            self._destroyFeaturedSlider();
            var imageId = $(self.selectors.productThumbs).find('.slick-active').find('.product-single__thumbnail').data('thumbnail-id');
            self._switchImage(imageId);
            self._setActiveThumbnail(imageId);
          }

          self.settings.bpSmall = false;
        },
        unmatch: function() {
          self._initFeaturedSlider();
          self._destroyThumbnailSlider();
          self._initThumbnailSlider();
        }
      });

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);


      if(this.variants.currentVariant.compare_at_price > this.variants.currentVariant.price ){
        currentVariantPrice = this.variants.currentVariant.compare_at_price;
      }
      else{
        currentVariantPrice = this.variants.currentVariant.price;
      }


      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      this.$container.on(
        'variantIDChange' + this.settings.namespace,
        this._updateVariantId.bind(this)
      );


      var container = this.$container;

      $(this.selectors.quantity).change(function(){
        container.trigger({
          type: 'variantPriceChange',
          variant: currentVariant
        });
      });

      var valTemp;
      $('.template-product .one-dish__more').on('click', function() {
        valTemp = $(this).parents('.one-dish__moreless').find('input[type=text]').val();
        valTemp++;
        $(this).parents('.one-dish__moreless').find('input[type=text]').val(valTemp);

        container.trigger({
          type: 'variantPriceChange',
          variant: currentVariant
        });
      });
      $('.template-product .one-dish__less').on('click', function() {
        valTemp = $(this).parents('.one-dish__moreless').find('input[type=text]').val();
        valTemp--;
        if(valTemp == 0) {}
        else {
          $(this).parents('.one-dish__moreless').find('input[type=text]').val(valTemp);
        }
        container.trigger({
          type: 'variantPriceChange',
          variant: currentVariant
        });
      });

    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on('click mouseover', function(evt) {
          evt.preventDefault();
          var $el = $(this);
          var imageId = $el.data('thumbnail-id');
          if (evt.type == 'click') {
            var currentSlide = $el.parent().attr('data-slick-index');
            $(self.selectors.productThumbs).find('.slick-slide').removeClass('slick-current');
            $(self.selectors.productThumbs).find('.slick-slide').eq(currentSlide).addClass('slick-current');
            if ($(self.selectors.productFeaturedWrapper).hasClass('slick-initialized') && !$(self.selectors.productFeaturedWrapper).find('.slick-slide').eq(currentSlide).hasClass('slick-current')) {
              $(self.selectors.productFeaturedWrapper).slick('slickGoTo', currentSlide);
            }
          } else {
            self._switchImage(imageId);
            self._setActiveThumbnail(imageId);
          }
        })
        .on('keyup', self._handleImageFocus.bind(self));
    },

    _initAddToCart: function() {
      var self = this;
      var $quantityInput = $(self.selectors.quantity);

      if ($quantityInput.length === 0) return;

      $(self.selectors.addToCart).on('click', function(evt) {
        var isInvalidQuantity = $quantityInput.val() <= 0;

        $(self.selectors.errorQuantityMessage).toggleClass(
          self.classes.hidden,
          !isInvalidQuantity
        );

        if (isInvalidQuantity) {
          $quantityInput
            .attr(
              'aria-describedby',
              'error-quantity-' + self.settings.sectionId
            )
            .attr('aria-invalid', true);
          $(self.selectors.errorQuantityMessage).focus();
          evt.preventDefault();
        } else {
          $quantityInput
            .removeAttr('aria-describedby')
            .removeAttr('aria-invalid');
        }
      });
    },

    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
        "[data-thumbnail-id='" +
        imageId +
        "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(activeClass)
        .removeAttr('aria-current');

      $thumbnail.addClass(activeClass);
      $thumbnail.attr('aria-current', true);

      //set active slick slide
      if($thumbnail.parents('.slick-slide').length > 0){
        var slideIndex = $thumbnail.parents('.slick-slide').attr('data-slick-index');
        $(this.selectors.productThumbs).slick('slickGoTo', parseInt(slideIndex));
      }

    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
        ":not([data-image-id='" +
        imageId +
        "'])",
        this.$container
      );

      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },

    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    _initThumbnailSlider: function() {
      if ($(this.selectors.productThumbs).find('.product-single__thumbnails-item').length == 1) {
        return false;
      }
      var windowWidth = $(window).width();
      var orientation = (window.screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;
      var options = {
        slidesToShow: $(this.selectors.productThumbs).find('.product-single__thumbnails-item').length < 4 ? $(this.selectors.productThumbs).find('.product-single__thumbnails-item').length : 4,
        slidesToScroll: 1,
        infinite: false,
        focusOnSelect: true,
        focusOnChange: true,
        arrows: true,
        nextArrow: '<div class="slick-button-next" aria-label="Next">' + theme.assets.icon_right + '</div>',
        prevArrow: '<div class="slick-button-prev" aria-label="Previous">' + theme.assets.icon_left + '</div>',
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 4,
              infinite: false,
              asNavFor: this.selectors.productFeaturedWrapper,
              vertical: false,
              verticalSwiping: false
            }
          }
        ]
      };

      if (windowWidth > 1199 || (windowWidth > 768 && (window.innerHeight > window.innerWidth))) {
        options.vertical = true;
        options.verticalSwiping = true;
        options.arrows = true;
      } else {
        options.responsive.push({
          breakpoint: 769,
          settings:   {
            slidesToShow: 4,
            vertical: false,
            verticalSwiping: false,
            infinite: false,
            asNavFor: this.selectors.productFeaturedWrapper,
            arrows: false
          }
        });
      }

      $(this.selectors.productThumbs).slick(options);

      if ($(this.selectors.productThumbs).hasClass('slick-initialized')) {
        $(this.selectors.productThumbs).find('.slick-arrow').on('mouseover', function () {
          var $el = $(this);
          if ($el.hasClass('slick-disabled')) {
            return false;
          }
          $el.trigger('click');
        });
      }

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container).find('.slick-list').removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container).find('.slick-disabled').removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _initFeaturedSlider: function() {
      if ($(window).width() > 1366) {
        return false;
      }
      if ($(this.selectors.productFeaturedWrapper).find('.product-single__photo-wrapper').length > 1) {
        var options = {
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          focusOnSelect: true,
          infinite: false,
          arrows: true,
          nextArrow: '<div class="slick-button-next" aria-label="Next">' + theme.assets.icon_right_mob + '</div>',
          prevArrow: '<div class="slick-button-prev" aria-label="Previous">' + theme.assets.icon_left_mob + '</div>',
          asNavFor: this.selectors.productThumbs
        };
        if (!$(this.selectors.productFeaturedWrapper).hasClass('slick-initialized')) {
          $(this.selectors.productFeaturedWrapper).slick(options);
        }

        this.settings.sliderMobileActive = true;
      }
    },

    _destroyThumbnailSlider: function() {
      if ($(this.selectors.productThumbs).hasClass('slick-initialized')) {
        $(this.selectors.productThumbs).slick('unslick');
      }
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _destroyFeaturedSlider: function() {
      if ($(this.selectors.productFeaturedWrapper).hasClass('slick-initialized')) {
        $(this.selectors.productFeaturedWrapper).slick('unslick');
      }
      this.settings.sliderMobileActive = false;
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var inventoryWrapper = this.container.querySelector(this.selectors.inventoryHtml);
      var variant = evt.variant;
      let variant_id;
      const cartButton = document.querySelector('.product-form__cart-submit');
      const qtyInput = document.querySelector('.quantity-input');
      if (typeof variant != 'undefined') {
        var currentStock = variantStock[variant.id];
        variant_id = variant.id.toString();
      }
      
      // console.log('autorized_v===>',autorized_v);
      // console.log('current_v===>',variant_id);

      
      if (isB2b && autorized_v.length > 0 && withVariants ){
          if (!autorized_v.includes(variant_id)) {
            cartButton.classList.add('hideBuyBtn');
            qtyInput.classList.add('hideBuyBtn');
            cartButton.textContent = 'Request for Information';
            console.log('Not autorized variant');
          } else {
            cartButton.classList.remove('hideBuyBtn');
            qtyInput.classList.remove('hideBuyBtn');
            cartButton.textContent = 'Add to cart';
            console.log('Autorized variant');
          }
      }
 
      

      let labels = document.querySelectorAll('#green_label');

      if (currentStock < 12) {  
        labels.forEach(function(el) {
          el.classList.add("low_stock");
          el.innerHTML = 'Low Stock';
        })
      } else if (currentStock > 11) {
        labels.forEach(function(el) {
          el.classList.remove("low_stock");
          el.innerHTML = 'In Stock';
        })
      }

      if (variant) {
        $(this.selectors.stockLabel).removeClass('invisible');
        if (variant.available) {

          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.shopifyPaymentButton, this.$container).show();

          if (variant.inventory_policy == 'continue' && variant.inventory_quantity <= 0) {
            $(this.selectors.addToCartText).text(theme.strings.preOrder);
            $(this.selectors.addToCart).closest('form').find('#preOrderInput').attr('name', 'properties[Type]');
            $(this.selectors.stockLabel).find('[data-stock="in"]').hide();
            $(this.selectors.stockLabel).find('[data-stock="out"]').show().find('.catalog-item__ships').show();
            
            // if (variantStock[variant.id] > 0 && variant.inventory_management == 'shopify' && inventoryWrapper !== null) {
            //         const inventoryHtml = `<p>Stock: ${variantStock[variant.id]}</p>`;
            //         inventoryWrapper.innerHTML = inventoryHtml;
            //       } else {
            //         inventoryWrapper.innerHTML = '';
            //   }
            
          } else {
            $(this.selectors.addToCartText).text(theme.strings.addToCart);
            $(this.selectors.addToCart).closest('form').find('#preOrderInput').attr('name', '');
            $(this.selectors.stockLabel).find('[data-stock="in"]').show();
            $(this.selectors.stockLabel).find('[data-stock="out"]').hide();
          }

          // if (typeof productObject != 'undefined'){
          //     for( var k in productObject.variants){
          //       if(productObject.variants[k].id == variant.id){
          // $('[data-unit-weight]').text(productObject.variants[k].weight_with_unit);
          //
          // if($('.single-option-selector[data-label="Voltage"]').length > 0){
          //   $('[data-specs-voltage]').text($('.single-option-selector[data-label="Voltage"]').val());
          // }
          //
          // if($('.single-option-selector[data-label="Feedback"]').length > 0) {
          //   $('[data-specs-feedback]').text($('.single-option-selector[data-label="Feedback"]').val() == 'Potentiometer' ? 'Yes' : 'No');
          // }
          // $('[data-specs-stroke]').text($('.single-option-selector[data-label="Stroke"]').val());
          // $('[data-specs-force]').text($('#Force_Select').val() ? $('#Force_Select').val() : $('.single-option-selector[data-label="Force"]').val());
          // $('[data-specs-speed]').text($('#Speed_Select').val() ? $('#Speed_Select').val() :$('.single-option-selector[data-label="Speed"]').val());
          // $('[data-specs="Total_Potentials"]').text(productObject.variants[k].Total_Potentials);
          // $('[data-specs="Total_Connection_Point"]').text(productObject.variants[k].Total_Connection_Point);
          // $('[data-specs="Length"]').text(productObject.variants[k].Length);
          // $('[data-specs="Width"]').text(productObject.variants[k].Width);
          //
          // $('[data-specs="TV_Size_Compatibility"]').text($('.single-option-selector[data-label="Size"]').val());
          // $('[data-specs="Stroke"]').text($('.single-option-selector[data-label="Stroke"]').val());
          // $('[data-specs="Minimum_Height"]').text(productObject.variants[k].Minimum_Height);
          // $('[data-specs="Maximum_Height"]').text(productObject.variants[k].Maximum_Height);
          // $('[data-specs="Overall_Dimensions"]').text(productObject.variants[k].Overall_Dimensions);
          //
          // $('[data-specs="Travel_Distance"]').text(productObject.variants[k].Travel_Distance);
          // $('[data-specs="Height_Range"]').text(productObject.variants[k].Height_Range);
          // $('[data-specs="Width_Adjustment"]').text(productObject.variants[k].Width_Adjustment);
          // $('[data-specs="Depth"]').text(productObject.variants[k].Depth);
          // $('[data-specs="Lifting_Capacity"]').text(productObject.variants[k].Lifting_Capacity);
          // $('[data-specs="Lifting_Mechanism"]').text(productObject.variants[k].Lifting_Mechanism);
          // $('[data-specs="Power_Saving"]').text(productObject.variants[k].Power_Saving);
          // $('[data-specs="Leveling"]').text(productObject.variants[k].Leveling);
          // $('[data-specs="Frame_Material"]').text(productObject.variants[k].Frame_Material);
          //         return;
          //       }
          //     }
          // }
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.addToCart).closest('form').find('#preOrderInput').attr('name', '');
          $(this.selectors.shopifyPaymentButton, this.$container).hide();

          $(this.selectors.stockLabel).find('[data-stock="in"]').hide();
          $(this.selectors.stockLabel).find('[data-stock="out"]').show().find('.catalog-item__ships').hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.stockLabel).addClass('invisible');
        $(this.selectors.addToCart).closest('form').find('#preOrderInput').attr('name', '');
        if($('#SingleOptionSelector-0').val() == '' || $('#SingleOptionSelector-1').val() == '' || $('#SingleOptionSelector-2').val() == ''){
          $(this.selectors.addToCartText).text("Make a Selection");
        } else{
          $(this.selectors.addToCartText).text(theme.strings.unavailable);
        }
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function(evt) {
      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

    //   console.log('variant - ', variant)

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);

      var qty = $(this.selectors.quantity).val();
      var quote = [];

      
      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr('aria-hidden');

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(variant.compare_at_price * qty, theme.moneyFormat)
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price * qty, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
        //quote = this._updateQuote(variant.price, qty);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price * qty, theme.moneyFormat)
        );

        

        var instant_quote = this._updateQuote(variant, qty);

        //console.log('instant_quote -> ',instant_quote);
        // console.log("variant ",variant);

        if(instant_quote){
          $regularPrice.html(theme.Currency.formatMoney(instant_quote, theme.moneyFormat));
        }

      }

    },

    _updateQuote: function(variant, qty) {

      let currentVariant = variant.id;
      let variant_price = variant.price;
      var quote = [];

      let min_7_props = document.querySelector('#min7_prop');
      let min_10_props = document.querySelector('#min10_prop');
      let min_20_props = document.querySelector('#min20_prop');
      let min_50_props = document.querySelector('#min50_prop');

      const min7_data = document.querySelector('#instantQuote7');
      const min10_data = document.querySelector('#instantQuote10');
      const min20_data = document.querySelector('#instantQuote20');
      const min50_data = document.querySelector('#instantQuote50');

      const popupVol7_price = document.querySelector('#instantQuote7_vol');
      const popupVol10_price = document.querySelector('#instantQuote10_vol');
      const popupVol20_price = document.querySelector('#instantQuote20_vol');
      const popupVol50_price = document.querySelector('#instantQuote50_vol');

      let discounted_price_min7 = null;
      let discounted_price_min10 = null;
      let discounted_price_min20 = null;
      let discounted_price_min50 = null;

      let discount_7_val = parseFloat(min7_data.dataset.discount);
      let discount_10_val = parseFloat(min10_data.dataset.discount);
      let discount_20_val = parseFloat(min20_data.dataset.discount);
      let discount_50_val = parseFloat(min50_data.dataset.discount);

      if (hasVariants) {
        if (discount_7_val != null || discount_7_val != isNaN) {
          min_7_props.value = discount_7_val;
        } else {
          console.log("No data discount");
          min_7_props.value = "";
        }
        if (discount_10_val != null || discount_10_val != isNaN) {
          min_10_props.value = discount_10_val;
        } else {
          min_10_props.value = "";
          console.log("No data discount");
        }
        if (discount_20_val != null || discount_20_val != isNaN) {
          min_20_props.value = discount_20_val;
        } else {
          min_20_props.value = "";
          console.log("No data discount");
        }
        if (discount_50_val != null || discount_50_val != isNaN) {
          min_50_props.value = discount_50_val;
        } else {
          min_50_props.value = "";
          console.log("No data discount");
        }
      }

      if(typeof currentVariant !== "undefined") {
        if (discount_7_val != null) {
          discounted_price_min7 = ((variant_price - (variant_price / 100 * discount_7_val)) / 100).toFixed(2);
          popupVol7_price.innerHTML = `$ ${discounted_price_min7} USD`;
        }
        if (discount_10_val != null) {
          discounted_price_min10 = ((variant_price - (variant_price / 100 * discount_10_val)) / 100).toFixed(2);
          popupVol10_price.innerHTML = `$ ${discounted_price_min10} USD`;
        }
        if (discount_20_val != null) {
          discounted_price_min20 = ((variant_price - (variant_price / 100 * discount_20_val)) / 100).toFixed(2);
          popupVol20_price.innerHTML = `$ ${discounted_price_min20} USD`;
        }
        if (discount_50_val != null) {
          discounted_price_min50 = ((variant_price - (variant_price / 100 * discount_50_val)) / 100).toFixed(2);
          popupVol50_price.innerHTML = `$ ${discounted_price_min50} USD`;
        }
      }






      console.log('currentVariant', currentVariant);
      console.log('instantQuote7', discount_7_val);
      console.log('hasVariants', hasVariants);
      console.log('variantPrice', variant_price);
      console.log('discounted_price_min7', discounted_price_min7);




      let minQty1 = 0;
      let minQty2 = 7;
      let minQty3 = 10;
      let minQty4 = 20;
      let minQty5 = 50;

      
      
      if(variant_price != null && variant_price != isNaN) {
        quote[0] = variant_price;
        console.log('quote[0] ',quote[0]);
      }
      if(discounted_price_min7 != null && discounted_price_min7 != isNaN) {
        quote[1] = discounted_price_min7;
        console.log('quote[1] ',quote[1]);
      }
      if(discounted_price_min10 != null && discounted_price_min10 != isNaN) {
        quote[2] = discounted_price_min10;
        console.log('quote[2] ',quote[2]);
      }
      if(discounted_price_min20 != null && discounted_price_min20 != isNaN) {
        quote[3] = discounted_price_min20;
        console.log('quote[3] ',quote[3]);
      }
      if(discounted_price_min50 != null && discounted_price_min50 != isNaN) {
        quote[4] = discounted_price_min50;
        console.log('quote[4] ',quote[4]);
      }
      quote[5] = null;



      if(qty != null && qty > 0 && qty < 7 ){
        quote[5] = quote[0] * qty;
      }
      if(qty != null && qty > 6 && qty < 10 ){
        quote[5] = quote[1] * qty;
      }
      if(qty != null && qty > 9 && qty < 20 ){
        quote[5] = quote[2] * qty;
      }
      if(qty != null && qty > 19 && qty < 50 ){
        quote[5] = quote[3] * qty;
      }
      if(qty != null && qty > 49 && qty < 100 ){
        quote[5] = quote[4] * qty;
      }
      if(qty != null && qty > 99){
        quote[5] = quote[4] * qty;
      }



      var instant_quote = null;
      let discounted_price = null;

      if ( qty != null && qty >= minQty1 && variant_price != null) {
        discounted_price = variant_price;
        instant_quote = discounted_price * qty;
      }
      if ( qty != null && qty >= minQty2 && discounted_price_min7 != null) {
        discounted_price = discounted_price_min7 * 100;
        instant_quote = discounted_price * qty;
      }
      if ( qty != null && qty >= minQty3 && discounted_price_min10 != null) {
        discounted_price = discounted_price_min10 * 100;
        instant_quote = discounted_price * qty;
      }
      if ( qty != null && qty >= minQty4 && discounted_price_min20 != null) {
        discounted_price = discounted_price_min20 * 100;
        instant_quote = discounted_price * qty;
      }
      if ( qty != null && qty >= minQty5 && discounted_price_min50 != null) {
        discounted_price = discounted_price_min50 * 100;
        instant_quote = discounted_price * qty;
      }

      //$(this).find('.col-price').text(theme.Currency.formatMoney(discounted_price, theme.moneyFormat));

      return instant_quote;
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },
    _updateVariantId: function(evt) {
      var variant = evt.variant;

      // Update the id
      $(this.selectors.variant_id).html(variant.id);
    },
    
    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    }
  }
);

window.addEventListener('DOMContentLoaded', function() {

  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);

  if(window.location.search.indexOf('variant=') > -1 ){
    $('#SingleOptionSelector-2').trigger("change");
  }

});

theme.init = function() {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a:not([aria-describedby], .product-single__thumbnail)')
  });

  theme.FormStatus.init();
};

$(theme.init);

// assets/custom.js
$(document).ready(function() {


  /* toping nav */
  $(".mobile-menu").on("click", ".topping__nav-name", function() {
    var navItem = $(this).parents(".topping__nav-item--drop");
    navItem.addClass("topping__nav-item--active");
    if(navItem.hasClass("topping__nav-item--active")){
      $(".mobile-menu-wrap").css("transform", "translateX(-100%)");
    }
  });

  $(".mobile-menu").on("click", ".topping__sub-name",  function() {
    var navItem = $(this).parents(".topping__sub-item");
    var dropdown = navItem.find(".topping__sub-dropdown-wrap");

    if (dropdown.is(":visible")) {
      navItem.removeClass("topping__sub-item--active");
      dropdown.stop().slideUp(400, function() {
        dropdown.css("height", "");
      });
    } else {
      var activeNav = $(".topping__sub-item--active");
      if (activeNav.length > 0) {
        activeNav.removeClass("topping__sub-item--active");
        var activeDropdown = activeNav.find(".topping__sub-dropdown-wrap");
        activeDropdown.stop().slideUp(400, function() {
          activeDropdown.css("height", "");
        });
      }
      navItem.addClass("topping__sub-item--active");
      dropdown.stop().slideDown(400, function() {
        dropdown.css("height", "");
      });
    }
  });
  $(".mobile-menu").on("click", ".topping__sub-dropdown-link",  function(e) {e.stopPropagation()});
  $(".mobile-menu").on("click", ".back-btn", function() {
    var navItem = $(this).parents(".topping__nav-item");
    $(".mobile-menu-wrap").css("transform", "translateX(0)");

    setTimeout((function () {
      navItem.removeClass("topping__nav-item--active");
    }), 400);

  });

  $(document).on("click", function(event) {

    if ($("#p80wTooltip").is(":visible")) {
      if ($(event.target).closest('[data-toggle="tooltip"]').length) return;
      hideTooltip();
      event.stopPropagation();
    }

    if (!$(event.target).closest("#col-mobile-search").length) {
      $("#HeaderQuickSearch").removeClass('suggestion-active');
      $("#HeaderQuickSearch .search-suggestions").stop().slideUp(200, function () {
        $("#HeaderQuickSearch .search-suggestions").css("height", "");
        $(".topping__search input").removeClass("active");
      });
    }

  });

  $('.site-redirect-selector').on('click',function () {
    $(this).toggleClass('open');
  })

  $('.selector-item').on('click', function (e) {
    e.stopPropagation();
    var redirectUrl = $(this).attr('data-url');
    window.location.href = redirectUrl;
  });

  jQuery(function($){
    $(document).mouseup(function (e){
      var div = $(".site-redirect-selector");
      if (!div.is(e.target)
        && div.has(e.target).length === 0) {
        $(".site-redirect-selector").removeClass('open');
      }
    });
  });

  $(".mobile-menu__trigger").on("click", function() {
    if ($(".mobile-menu").is(":visible")) {
      $(".mobile-menu").slideUp(400);
      $(".mobile-menu__fog")
        .stop()
        .animate({ opacity: 0 }, 400, function() {
          $(this).hide();
        });
    } else {
      $(".mobile-menu").slideDown(400);
      $(".mobile-menu__fog")
        .show()
        .stop()
        .animate({ opacity: 1 }, 400);
    }
  });
  $(".mobile-menu__fog").on("click", function() {
    $(".mobile-menu").slideUp(400);
    $(".mobile-menu__fog")
      .stop()
      .animate({ opacity: 0 }, 400, function() {
        $(this).hide();
      });
  });

  $(".catalog-page__menu-item-line").on("click", function(e) {
    e.stopPropagation();
    $(this).toggleClass("selected");
    if (
      $(this)
        .parent("ul")
        .find(".catalog-page__menu-item-line.selected").length > 0
    ) {
      $(this)
        .parent("ul")
        .addClass("active");
    } else {
      $(this)
        .parent("ul")
        .removeClass("active");
    }
    filterCollection();

    if ( $(".catalog-page__menu").height() > $(".catalog-page__content").height()) {
      $(".catalog-page__menu").css("position", "static")
    }
    else {
      $(".catalog-page__menu").css("position", "");
    }
  });

  $(".catalog-page__menu-item .search-filter__cntrl-clear").on(
    "click",
    function(e) {
      $(".catalog-page__menu-item [data-filter]").removeClass("active");
      $(".catalog-page__menu-item .catalog-page__menu-item-line").removeClass(
        "selected"
      );
      $(".catalog-page__menu-item-trigger--active").each(function() {
        $(this).trigger("click");
      });
      filterCollection();
    }
  );

  $("#blogSearch").submit(function(e) {
    e.preventDefault();
    var k = $("#blogSearch .blog__cntrl-search-input")
      .val()
      .toLowerCase();
    if (k != "") {
      $(".blog__content .blog__item")
        .removeClass("active-item")
        .hide();
      var count = $(".blog__content .blog__item").length;
      $(".blog__content .blog__item").each(function(i) {
        var article_title = $(this)
          .find(".featured__item-name")
          .text()
          .toLowerCase();
        var article_content = $(this)
          .find(".featured__item-text")
          .text()
          .toLowerCase();
        var tags = $(this)
          .data("tags")
          .toLowerCase();
        if (
          article_title.indexOf(k) != -1 ||
          article_content.indexOf(k) != -1 ||
          tags.indexOf(k) != -1
        ) {
          $(this)
            .addClass("active-item")
            .hide();
        }
        if (i + 1 === count) {
          LoadMoreBlog();
        }
      });
      if ($(".blog__content .active-item").length) {
        $(".blog__content .no-result")
          .text($(".blog__content .no-result").data("text"))
          .fadeIn();
      }
      else {
        $(".blog__content .no-result").text("").fadeOut();
      }
    }
    else {
      $(".blog__content .blog__item").addClass("active-item");
    }
    $(".blog__content .no-result").text("").fadeOut();
    LoadMoreBlog();
    $("html,body").animate(
      {
        scrollTop: $("#blogRow").offset().top
      },
      "fast"
    );
  });

  $(".blog__content .btn-load-more").on("click", function(e) {
    e.preventDefault();
    LoadMoreBlog();
  });

  $("#blogSearch .blog__cntrl-search-input").on("keyup", function(e) {
    if ($(this).val() == "") {
      $(".blog__content .blog__item").addClass("active-item");
      $(".blog__content .no-result").text("").fadeOut();
      LoadMoreBlog();
    }
  });

  var swiperMain = new Swiper(".template-index .swiper-container--main", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    speed: 3000,
    navigation: {
      nextEl: ".template-index .swiper-button-next--main",
      prevEl: ".template-index .swiper-button-prev--main"
    }
  });


  var swiperTopBrands = new Swiper(".swiper-container--top-brands", {
    slidesPerView: 6,
    slidesPerGroup: 6,
    autoplay: {
      delay: 2000
    },
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next--top-brands",
      prevEl: ".swiper-button-prev--top-brands"
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      1479: {
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    }
  });

  setTimeout( function() {

    swiperTopBrands.update();

  }, 500);

    var swiperSolution = new Swiper(".swiper-container--solution", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        /*autoplay: {
            delay: 2000
        },*/
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next--solution",
            prevEl: ".swiper-button-prev--solution"
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
        }
    });

  var swiperAlsoWant = new Swiper(".swiper-container--also-want", {
    roundLengths: true,
    slidesPerView: 4,
    followFinger: false,
    pagination: {
      el: ".swiper-pagination--also-want",
      clickable: true
    },
    breakpoints: {
      575: {
        slidesPerView: 1
      },
      991: {
        slidesPerView: 2
      }
    }
  });

  if ($(".search-filter").length) {
    $(".select2-filer--type").select2({
      width: "100%",
      minimumResultsForSearch: Infinity,
      theme: "filter",
      placeholder: "Type"
    });
    $(".select2-filer--stroke").select2({
      width: "100%",
      minimumResultsForSearch: Infinity,
      theme: "filter",
      placeholder: "Stroke"
    });
    $(".select2-filer--force").select2({
      width: "100%",
      minimumResultsForSearch: Infinity,
      theme: "filter",
      placeholder: "Force"
    });
    $(".select2-filer--speed").select2({
      width: "100%",
      minimumResultsForSearch: Infinity,
      theme: "filter",
      placeholder: "Speed"
    });
  }
  $(".select2-filer").on("select2:open", function(e) {
    $(".select2-results__options")
      .scrollbar()
      .parent()
      .addClass("scrollbar-inner");
  });

  $(".search-filter__cntrl-search").on("click", function() {
    var queryString = "/collections/linear-actuators?";
    var params = "";
    $(".search-filter__content select").each(function() {
      if (
        params == "" &&
        $(this).val() != "" &&
        $(this).val() != "Type" &&
        $(this).val() != "Stroke" &&
        $(this).val() != "Force" &&
        $(this).val() != "Speed"
      ) {
        params = $(this).data("filter") + "=" + $(this).val();
      } else if (
        $(this).val() != "" &&
        $(this).val() != "Type" &&
        $(this).val() != "Stroke" &&
        $(this).val() != "Force" &&
        $(this).val() != "Speed"
      ) {
        params += "&" + $(this).data("filter") + "=" + $(this).val();
      }
    });
    if (params != "") {
      window.location.href = queryString + params;
    }
  });


  $(".resources__cntrl-search-input").on("keyup", function(e) {
    var code = e.keyCode || e.which;
    if (code == 13) {
      $(this)
        .next(".resources__cntrl-search-button")
        .trigger("click");
    }
    if ($(this).val() == "") {
      $(this)
        .next(".resources__cntrl-search-button")
        .trigger("click");
    }
  });

  $(".resources__cntrl-search-button:not(.faq)").on("click", function() {
    var k = $(this)
    .prev(".resources__cntrl-search-input")
    .val()
    .toLowerCase()
    .replace(/\s+/g, " ").replace(/^\s|\s$/g, "");
    k = k.split(' ');
    var found = 0;
    if (k != "") {
      $('.resources__item-block').removeClass('tabs__button--active');
      $('.tabs--wide').addClass('hide');
      $('.tabs--wide').each(function() {
        $this = $(this);
        var item = $(this).find(".col-item");
        item.fadeOut("fast");
        $(this).find(".col-item").each(function() {
          $(this).fadeOut("fast");
          $this_item = $(this);
          $.each(k, function() {
            if ($this_item.data("title").toLowerCase().indexOf(this) > -1 || $this_item.text().toLowerCase().indexOf(this) > -1) {
              $this.removeClass("hide");
              $this.find('.resources__item-block').addClass('tabs__button--active');
              $this_item.fadeIn("fast").addClass('test');
              found++;
            }
          });
        });
        if(found == 0){
          $('.resources__item').hide();
          $('.empty-answer').addClass('active');
        }else{
          $('.resources__item').show();
          $('.empty-answer').removeClass('active');
        }
      });
    } else {
      $('.resources__item').show();
      $('.empty-answer').removeClass('active');
      $(".col-item").show();
      $('.tabs--wide').removeClass("hide");
      $('.resources__item-block').removeClass('tabs__button--active');
    }
  });
  if ($(".catalog-page").length > 0) {
    var url = window.location.href;
    var queryString = url ? url.split("?")[1] : window.location.search.slice(1);
    if (queryString) {
      var filters = getAllUrlParams(url);
      for (var filter in filters) {
        if (Array.isArray(filters[filter])) {
          var filterLength = filters[filter].length;
          for (var i = 0; i < filterLength; i++) {
            var fil = filters[filter][i];
            var value = fil.replace("%20", " ");
            $('[data-filter="' + filter + '"]').find('li[data-value="' + value + '"]').click();
            setFilterOpened(filter);

          }
        } else {
          var value = filters[filter].replace("%20", " ");
          $('[data-filter="' + filter + '"]').find('li[data-value="' + value + '"]').click();
          setFilterOpened(filter);
        }
      }
    }
  }

  function setFilterOpened(filter) {
    var catalogMenu = $('[data-filter="' + filter + '"]').parent();
    var catalogTitle = catalogMenu.prev();
    if (!catalogTitle.hasClass('catalog-page__menu-item-trigger--active')) {
      catalogTitle.addClass('catalog-page__menu-item-trigger--active');
      catalogMenu.show();
    }
  }

  function getAllUrlParams(url) {
    // get query string from url (optional) or window
    var queryString = url ? url.split("?")[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {
      // stuff after # is not part of query string, so get rid of it
      queryString = queryString.split("#")[0];

      // split our query string into its component parts
      var arr = queryString.split("&");

      for (var i = 0; i < arr.length; i++) {
        // separate the keys and the values
        var a = arr[i].split("=");

        // set parameter name and value (use 'true' if empty)
        var paramName = a[0];
        var paramValue = typeof a[1] === "undefined" ? true : a[1];

        // (optional) keep case consistent
        paramName = paramName.toLowerCase();
        //if (typeof paramValue === 'string') paramValue = paramValue.replace("%20", " ");

        // if the paramName ends with square brackets, e.g. colors[] or colors[2]
        if (paramName.match(/\[(\d+)?\]$/)) {
          // create key if it doesn't exist
          var key = paramName.replace(/\[(\d+)?\]/, "");
          if (!obj[key]) obj[key] = [];

          // if it's an indexed array e.g. colors[2]
          if (paramName.match(/\[\d+\]$/)) {
            // get the index value and add the entry at the appropriate position
            var index = /\[(\d+)\]/.exec(paramName)[1];
            obj[key][index] = paramValue;
          } else {
            // otherwise add the value to the end of the array
            obj[key].push(paramValue);
          }
        } else {
          // we're dealing with a string
          if (!obj[paramName]) {
            // if it doesn't exist, create property
            obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === "string") {
            // if property does exist and it's a string, convert it to an array
            obj[paramName] = [obj[paramName]];
            obj[paramName].push(paramValue);
          } else {
            // otherwise add the property
            obj[paramName].push(paramValue);
          }
        }
      }
    }

    return obj;
  }
  if ($(".catalog-page").length > 0) {
    $(".catalog-page__menu-item").each(function() {
      if ($(this).find(".catalog-page__menu-item-line.selected").length > 0) {
        $(this)
          .find(".catalog-page__menu-item-trigger")
          .trigger("click");
      }
    });
  }


  $(".search-filter__trigger").on("click", function() {
    if ($(window).width() < 991) {
      $(this).toggleClass("search-filter__trigger--active");
      $(".search-filter__trigger-object").slideToggle(400);
    }
  });

  $(".catalog-page__menu-item-trigger").on("click", function() {
    $(this).toggleClass("catalog-page__menu-item-trigger--active");
    $(this)
      .siblings(".catalog-page__menu-item-content")
      .slideToggle(400);
  });

  $(".accordion-text-blocks .block-item .arrow-top").on("click", function() {
    var parent = $(this).parents(".block-item");
    if ($(parent).hasClass("closed")) {
      $(parent)
        .find(".block-content")
        .stop()
        .slideDown("fast", function() {
          $(parent).removeClass("closed");
        });
      return;
    }
    $(parent)
      .find(".block-content")
      .stop()
      .slideUp("fast", function() {
        $(parent).addClass("closed");
      });
  });

  if ($(".select2-product").length) {
    $(".select2-product").select2({
      width: "100%",
      minimumResultsForSearch: Infinity,
      theme: "product",
      placeholder: "Select"
    });
  }
  $(".select2-product").on("select2:open", function(e) {
    $(".select2-results__options")
      .scrollbar()
      .parent()
      .addClass("scrollbar-inner");
  });

  var valTemp;
  $(".template-cart .one-dish__more").on("click", function() {
    valTemp = $(this)
      .parents(".one-dish__moreless")
      .find("input[type=text]")
      .val();
    valTemp++;
    $(this)
      .parents(".one-dish__moreless")
      .find("input[type=text]")
      .val(valTemp);
    if ($(this).parents(".cart__list").length > 0) {
      showProgress();
    }
  });
  $(".template-cart .one-dish__less").on("click", function() {
    valTemp = $(this)
      .parents(".one-dish__moreless")
      .find("input[type=text]")
      .val();
    valTemp--;
    if (valTemp == 0) {
    } else {
      $(this)
        .parents(".one-dish__moreless")
        .find("input[type=text]")
        .val(valTemp);
    }
    if ($(this).parents(".cart__list").length > 0) {
      showProgress();
    }
  });

  $(".cart__list .cart__qty-input").on("focus", function() {
    valTemp = $(this).val();
  });
  $(".cart__list .cart__qty-input").on("focusout", function() {
    if (valTemp != $(this).val()) {
      showProgress();
      window.location.href = $(this).data("update-url") + $(this).val();
    }
  });

  $(".cart__list .cart__qty-input").on("keyup", function(e) {
    e.preventDefault();
    var code = e.keyCode || e.which;
    if (isNaN($(this).val())) {
      $(this).val(valTemp);
    }
    if (code == 13) {
      showProgress();
      window.location.href = $(this).data("update-url") + $(this).val();
    }
  });

  $(".catalog-info__item-collapse").on("click", function() {
    $(this).toggleClass('active').next().slideToggle(400);
  });

  $(".tabs").on("click", ".tabs__button", function(e) {
    e.stopPropagation();
    if (!$(this).hasClass("tabs__button--active")) {
      $(this).siblings(".tabs__button--active").removeClass("tabs__button--active");
      if ($(this).parents(".tabs--wide").length) {
        $(this).siblings(".tabs__item:visible").slideUp(400);
        $(this).next(".tabs__item").slideDown(400);
      } else {
        $(this).siblings(".tabs__item:visible").hide();
        $(this).next(".tabs__item").show();
      }
      $(this).addClass("tabs__button--active");
    } else if ($(this).hasClass("tabs__button--active")) {
      $(this).removeClass("tabs__button--active");
      $(this).next(".tabs__item").slideUp(400);
    }

    if($(this).find('span').text() == 'Media'){
      $('.product-articles-slider').slick("setPosition");
    }

    if ($(this).data("hash")) {
      window.history.pushState(
        null,
        null,
        window.location.pathname + $(this).data("hash")
      );
    }
  });

  if (window.location.hash) {
    if (window.location.pathname == "/pages/resources") {
      $('.tabs [data-hash="' + window.location.hash + '"]').trigger("click");
    }
    $(window).on("hashchange", function() {
      $('.tabs [data-hash="' + window.location.hash + '"]').trigger("click");
    });
  }

  var swiperAlsoWant = new Swiper(".swiper-container--recently1", {
    slidesPerView: 6,
    followFinger: false,
    observer: true,
    observeParents: true,
    pagination: {
      el: ".swiper-pagination--recently1",
      clickable: true
    },
    breakpoints: {
      767: {
        slidesPerView: 1,
        followFinger: true
      },
      991: {
        slidesPerView: 2,
        followFinger: true
      },
      1199: {
        slidesPerView: 3,
        followFinger: true
      },
      1519: {
        slidesPerView: 4,
        followFinger: true
      }
    }
  });

  if ($(".select2-search").length) {
    $(".select2-search").select2({
      width: "100%",
      minimumResultsForSearch: Infinity,
      theme: "search"
    });
  }
  $(".select2-search").on("select2:open", function(e) {
    $(".select2-results__options")
      .scrollbar()
      .parent()
      .addClass("scrollbar-inner");
  });

  $(".cart__pay-method-header").on("click", function() {
    $(this)
      .parent(".cart__pay-method-block")
      .toggleClass("cart__pay-method-block--active");
    $(this)
      .siblings(".cart__pay-method-content")
      .slideToggle(400);
  });

  $(".topping_search_mobile").on("click", function(e) {
    e.preventDefault();
    $("#HeaderQuickSearch .search-suggestions").css("display", 'none');
    $("#col-mobile-search").addClass('active');
  });

  var swiperAddress = new Swiper(".swiper-container--address", {
    spaceBetween: 30,
    roundLengths: true,
    pagination: {
      el: ".swiper-pagination--address",
      clickable: true,
      renderBullet: function (index, className) {
        return namesAr = this.slides, namesEl = $(namesAr[index]).data("tabname"), '<span class="' + className + '">' + namesEl + "</span>"
      }
    }
  });

  $(".dashboard__orders-details-button").on("click", function(event) {
    event.preventDefault();
    $(this).toggleClass("dashboard__orders-details-button--active");
    $(this)
      .parents(".dashboard__orders-table-row")
      .find(".dashboard__list")
      .slideToggle(400);
  });

  if ($('.blog-page__soc-item[data-social-share="facebook"]').length > 0) {
    var url =
      "https://graph.facebook.com/?id=" +
      $('.blog-page__soc-item[data-social-share="facebook"]').data("share-url");
    $.getJSON(url, function(data) {
      if (data.share) {
        $('.blog-page__soc-item[data-social-share="facebook"]').append(
          '<span class="count">' + data.share.share_count + "</span>"
        );
      }
    });
  }

  function showTooltip(elem) {
    $("#p80wTooltip").attr("style", "");
    $("#p80wTooltip .tooltip-inner").html("");
    var content = $(elem).data("tooltip-content")
      ? $(elem).data("tooltip-content")
      : $(elem).attr("title");
    $("#p80wTooltip .tooltip-inner").html(
      content.replace("href", 'target="_blank" href')
    );
    var posX = $(elem).offset().left,
      posY = $(elem).offset().top;
    var contentWidth = $("#p80wTooltip").width();
    var contentHeight = $("#p80wTooltip").height();
    var elemWidth = $(elem).width();
    var elemHeight = $(elem).height();
    var contentCenter = contentWidth / 2 - elemWidth / 2;
    var left = posX - contentCenter;
    var top = posY - contentHeight - elemHeight;
    if (left < 1) {
      left = 10;
      contentCenter = posX - 10;
    }
    $("#p80wTooltip .arrow").css("left", contentCenter + "px");
    $("#p80wTooltip").css("left", left + "px");
    $("#p80wTooltip").css("top", top + "px");
    $("#p80wTooltip").addClass("fade bs-tooltip-top show");
  }

  function hideTooltip() {
    $("#p80wTooltip").removeClass("fade bs-tooltip-top show");
    $("#p80wTooltip").attr("style", "");
    $("#p80wTooltip .tooltip-inner").html("");
  }

  function setParam(key, value) {
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + key + '=' + value;
    window.history.replaceState({ path: newurl }, '', newurl);
  }

  function LoadMoreBlog(num) {
    let totalNum = $(".blog__item.active-item").length;
    let totalPagNumber = parseInt(totalNum / 6);
    let prePagination = $(".pro-auto__pagination");
    if (prePagination == undefined) {
      return false;
    }
    let query = 'page';
    if ($('body').hasClass('template-blog')) {
      query = 'view';
    }
    let nextPageHref = prePagination.find('.btn-load-more').attr('href');
    let nextPageNum = parseInt(nextPageHref.split(query + '=')[1]);
    if (num != undefined) {
      nextPageNum = parseInt(num);
    }
    let counter = nextPageNum * 6;
    $(".blog__item.active-item").each(function(i) {
      let el = $(this);
      if (i >= counter) return false;
      if (el.is(':hidden')) {
        el.fadeIn();
      }
    });
    if ($(".blog__item.active-item:hidden").length == 0) {
      setParam(query, totalPagNumber);
      prePagination.hide();
      prePagination.find('.btn-load-more').attr('href', nextPageHref.split(query + '=')[0] + + query + '=' + totalPagNumber);
    } else {
      setParam(query, nextPageNum);
      prePagination.show();
      prePagination.find('.btn-load-more').attr('href', nextPageHref.split(query + '=')[0] + query + '=' + (nextPageNum + 1));
    }
  }



  let querySearch = function getQueryParams() {
    let qs = document.location.search;
    qs = qs.split('+').join(' ');
    var params = {},
      tokens,
      re = /[?&]?([^=]+)=([^&]*)/g;
    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }
    return params;
  }

  if ($('body').hasClass('template-blog') && querySearch.view != undefined
    || $('body').hasClass('template-page') && querySearch.page != undefined) {
    LoadMoreBlog(querySearch.view || querySearch.page);
  }

  $(".ajax-add-cart").on("click", function(e) {
    e.preventDefault();
    var btn_elem = $(this);
    if (btn_elem.hasClass("btn-view-cart")) {
      window.location.href = "/cart";
    }
    else {
      var variant_id = btn_elem.data("variant");
      let discount_7 = btn_elem.data("min_7");
      let discount_10 = btn_elem.data("min_10");
      let discount_20 = btn_elem.data("min_20");
      
    //   console.log('discount_7',discount_7)
    //   console.log('discount_10',discount_10)
    //   console.log('discount_20',discount_20)
      
      if (variant_id) {
        var params = {
          quantity: 1,
          id: variant_id,
          properties: {
          'discount_min7': discount_7,
          'discount_min10': discount_10,
          'discount_min20': discount_20
          }
        };
        if (btn_elem.hasClass('catalog-page__item-pre-order')) {
          params.properties = {
            'Type': theme.strings.preOrder
          };
        }
        showProgress();
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: params,
          dataType: "json"
        })
          .done(function(t) {
            var message = t.product_title + " has been added to cart!";
            $("#ajax-progress").hide("fast");
            $("#ajax-overlay").fadeOut("fast", function() {
              btn_elem.addClass("btn-view-cart").html("<span>View Cart</span>");
            });
            Shopify.onItemAdded(t);
          })
          .fail(function(t, r) {
            $("#ajax-message").fadeOut("fast");
            $("#ajax-overlay").fadeOut("fast");
            alert(r);
          });
      }
    }
  });

  $('[data-tooltip-toggle="click"]').on("click", function() {
    showTooltip($(this));
  });

  $('[data-tooltip-toggle="hover"]')
    .on("mouseenter", function() {
      showTooltip($(this));
    })
    .on("mouseleave", function() {
      hideTooltip();
    });

  $(".iframe-wrapper").each((function () {
    0 == $(this).parents(".video-wrapper").length &&
    ($(this).find('iframe[data-src*="youtube.com/embed"]').length > 0 ||
      $(this).find('iframe[src*="youtube.com/embed"]').length > 0)
    && ($(this).find("iframe").hasClass("responsive-video") ?
      $(this).addClass("responsive-video-wrapper") : $(this).addClass("video-wrapper"))
  }));

  if (typeof productOptions != "undefined") {

    var i = 0;

    $(".single-option-selector-product-template").each( function() {

      var option_name = $(this).data("label");
      var option_values = [];
      var selected = $("#SingleOptionSelector-" + i).val();

      $("#SingleOptionSelector-" + i + " > option").each( function() {

        option_values.push(this.value);

      });

      option_values.sort(sortOption);

      var optionHtml = '<option value="">Select ' + option_name + "</option>";

      for (var k in option_values) {

        if (option_values[k] == selected) {

          optionHtml +=
            "<option value='" +
            option_values[k] +
            "' selected='selected'>" +
            option_values[k] +
            "</option>";

        }

        else {

          optionHtml +=
            "<option value='" +
            option_values[k] +
            "'>" +
            option_values[k] +
            "</option>";

        }
      }

      $("#SingleOptionSelector-" + i).html(optionHtml);

      if (selected_variant == "") {

        $("#SingleOptionSelector-" + i).val("");
        $("#SingleOptionSelector-" + i).val("");

      }

      i++;

    });
    if (productOptions.length > 1 && selected_variant == "") {

      $("#AddToCartText-product-template").text("Make a Selection");
      $('.catalog-item__abs-block').addClass('invisible');
      $("#AddToCart-product-template").prop("disabled", true);
      $("#SingleOptionSelector-1").prop("disabled", true);
      $("#SingleOptionSelector-2").prop("disabled", true);
      $("#Force_Select").prop("disabled", true);

    } else if (productOptions.length == 1 && productObject.variants.length > 1 && selected_variant == "") {
      $("#AddToCartText-product-template").text("Make a Selection");
      $('.catalog-item__abs-block').addClass('invisible');
      $("#AddToCart-product-template").prop("disabled", true);
    }
  }

  function sortOption(a, b) {

    return parseFloat(a) - parseFloat(b);

  }



  if ($("#shopify-section-product-template").length > 0) {
    var storageKey = "pa_recently_viewed";
    var recently_viewed = [];
    if (localStorage.getItem(storageKey)) {
      var retrievedObject = localStorage.getItem(storageKey);
      var local_object = JSON.parse(retrievedObject);
      var new_local_object = [];
      var recent_viewed_object = {};
      recent_viewed_object.products = {};
      var tab_content = $('<div id="recently-viewed__slider" class="row recently-viewed__item"/>');
      var recently_view_items_html = "";
      var recent_count = 0;
      for (var k in local_object) {
        var variant_id = local_object[k].id;
        if (
          typeof recent_viewed_object.products[variant_id] == "undefined" &&
          local_object[k].id != productObject.id &&
          recent_count < 6
        ) {
          recent_viewed_object.products[variant_id] = local_object[k];
          recently_view_items_html += local_object[k].swiper_html;
          new_local_object.push(local_object[k]);
          recent_count++;
        }
      }
      tab_content.html(recently_view_items_html);
      $(".recently-viewed .tabs").append(tab_content);
      if (recent_count > 0) {
        $(".recently-viewed").show();
      }
      if ($(".recently-viewed .catalog-page__item").length == 1) {
        $(".recently-viewed .tabs__button").trigger("click");
      }


      $('[data-tooltip-toggle="hover"]')
        .on("mouseenter", function() {
          showTooltip($(this));
        })
        .on("mouseleave", function() {
          hideTooltip();
        });

      new_local_object.unshift(productObject);
      var storage_arr = new_local_object.splice(0, 7);
      localStorage.setItem(storageKey, JSON.stringify(storage_arr));
    } else {
      if ("localStorage" in window) {
        recently_viewed[0] = productObject;
        localStorage.setItem(storageKey, JSON.stringify(recently_viewed));
      }
    }
  }

  function clearStorage() {
    Object.keys(localStorage).forEach(function(key) {
      if (key.indexOf("configure") !== -1) {
        localStorage.removeItem(key);
      }
    });
  }

  $(".address-new-toggle").on("click", function(e) {
    e.preventDefault();
    $.fancybox.open({
      src: "#AddressNewForm",
      opts: {
        afterShow: function(instance, current) {
          $("#address_form_new").on("submit", function() {
            dataLayer.push({
              event: "Account",
              eventCategory: "Form",
              eventAction: "Success",
              eventLabel: "Address Book"
            });
          });
        }
      }
    });
  });

  if ($(".contact-success .thank-you-message").length > 0) {
    dataLayer.push({
      event: "Send",
      eventCategory: "Form",
      eventAction: "Success",
      eventLabel: "Contact Us"
    });
  }

  if ($('[data-section-id="actuator-collection-template"]').length > 0) {
    var top_limit = $(".catalog-page__wrap").offset().top;
    $(window).on("scroll", function() {
      var bottom_limit =
        $(".also-want").offset().top - $(".catalog-page__menu").height();

      if($(".catalog-page__menu").height() > $(".catalog-page__content").height()) {
        $(".catalog-page__menu").css("position", "static")
      }
      else {
        $(".catalog-page__menu").css("position", "")
      }

      if ($(window).scrollTop() > top_limit) {
        $(".catalog-page__menu").addClass("isSticky");
      } else {
        $(".catalog-page__menu").removeClass("isSticky");
      }

      if ($(window).scrollTop() > bottom_limit) {
        $(".catalog-page__menu").addClass("isBottomSticky");
      } else {
        $(".catalog-page__menu").removeClass("isBottomSticky");
      }
    });
  }

  $(".actuator-info-table").each(function () {
    var table = $(this);
    table.find("thead th").each(function (index) {
      table.find("tbody td:nth-of-type(" + (index + 1) + ")")
        .attr("data-head", $(this).text());
    });
  });

  $(".topping__search #button_submit").on("click", function () {
    if($(".topping__search input").hasClass("active") && $(".topping__search input").val() != "") {
      $("form.topping__search").submit();
    }
    else {
      $(".topping__search input").addClass("active");
    }

    $(".topping__search input").focus();

  });

  var suggestion_item_template = "";

  if($('.product-suggestions .item').length > 0) {
    suggestion_item_template = 	$('.product-suggestions .item').html();
  }

  $('.topping__search input[name="q"]').on("keyup", function () {
    var searchKey = $(this).val();
    var searchUrl = "/search?q="+ $(this).val() +"&type=product";
    if($(this).val().length > 2) {
      $("#HeaderQuickSearch").removeClass('suggestion-active');
      $("#HeaderQuickSearch").addClass('show-loader');
      jQuery.getJSON("/search/suggest.json", {
        s: $(this).val(),
        resources: {
          types: ["product"],
          limit: 6,
          options: {
            fields: "variants.sku,title,variants.title,variants.barcode,tag,product_type"
          }
        }
      }).done(function (response) {
        $("#HeaderQuickSearch").removeClass('show-loader');
        var productSuggestions = response.resources.results.products;
        var resultHtml = "";
        if (productSuggestions.length > 0) {
          for (var i in productSuggestions) {
            var itemUrl = productSuggestions[i].url.split("?");
            resultHtml +=
              '<div class="item">' +
              '<div class="col-img">' +
              '<a href="' + itemUrl[0] + '" title="' + productSuggestions[i].title + '">'+
              '<img src="' + productSuggestions[i].image + '" alt="' + productSuggestions[i].title + '"/>' +
              '</a>' +
              '</div>' +
              '<div class="product-info">' +
              '<h3 class="product-title">' +
              '<a href="' + itemUrl[0] + '" title="' + productSuggestions[i].title + '">' +
              productSuggestions[i].title +
              '</a>' +
              '</h3>' +
              '<div class="product-stock">' +
              (productSuggestions[i].available ? "In stock" : "Out of Stock") +
              '</div>' +
              '<div class="product-price">$' +
              productSuggestions[i].price +
              '</div>' +
              '</div>' +
              '</div>';
          }
          $("#HeaderQuickSearch .product-suggestions").html(resultHtml);
          $("#HeaderQuickSearch").addClass('suggestion-active');
          $("#HeaderQuickSearch .search-suggestions").stop().slideDown(400, function () {
            $("#HeaderQuickSearch .search-suggestions").css("height", "");
          });
          $("#HeaderQuickSearch .block-footer a").attr("href", searchUrl);
        }
        else{
          $("#HeaderQuickSearch .product-suggestions").html("");
          $("#HeaderQuickSearch").removeClass('suggestion-active');
          $("#HeaderQuickSearch .search-suggestions").stop().slideUp(200, function () {
            $("#HeaderQuickSearch .search-suggestions").css("height", "");
          });
        }
      });
    }
    else {
      $("#HeaderQuickSearch").removeClass('suggestion-active');
      $("#HeaderQuickSearch .search-suggestions").stop().slideUp(200, function () {
        $("#HeaderQuickSearch .search-suggestions").css("height", "");
      });
    }
  });

  $("#HeaderQuickSearch .block-footer a").on("click", function(e){
    window.location.href = $(this).attr("href");
  });

  $('#HeaderQuickSearch .close-btn').on('click', function() {
    if($('#col-mobile-search.active').length > 0){
      $('#col-mobile-search').removeClass('active');
    }
    else{
      $("#HeaderQuickSearch .search-suggestions").stop().slideUp(200, function () {
        $("#HeaderQuickSearch .search-suggestions").css("height", "");
        $("#HeaderQuickSearch").removeClass('suggestion-active');
      });
    }
  });

  var searchPage = 1,
    visibleItems = $(".search-results .catalog-page__item").length,
    searchKey = $(".mobile-search #SearchInput").val();

  function LoadMoreSearchResult(page) {
    $("#ajax-overlay").show();
    $("#ajax-progress").show();
    jQuery.ajax({
      url: "/search?page=" + page + "&q=" + searchKey + "&type=product&view=json",
      dataType: "json",
      success: function (data) {

        if (_.size(data.results) > 0) {
          for (var i in data.results) {
            $(".catalog-page .search-results").append(data.results[i].item_html);
          }
          visibleItems += Number(_.size(data.results));
          $(".catalog-page__top-line-amount span").text(Number(visibleItems));
        }

        if(visibleItems >= data.results_count) {
          $(".pro-auto__pagination").hide();
          $(".catalog-page__top-line-amount span").text(Number(visibleItems));
        }

      },
      complete: function () {
        $('[data-tooltip-toggle="click"]').on("click", function () {
          showTooltip($(this))
        });
        $('[data-tooltip-toggle="hover"]').on("mouseenter", function () {
          showTooltip($(this));
        }).on("mouseleave", function () {
          hideTooltip();
        });
        $("#ajax-overlay").hide();
        $("#ajax-progress").hide();
        searchPage++;
      }
    });
  }

  $(".template-search .btn-load-more").on("click", function (e) {
    e.preventDefault();
    LoadMoreSearchResult(searchPage + 1);
  });

  $('.filter-toggle__btn, .filter-head .icon-close').on('click', function() {
    $('body').toggleClass('filter-open');
  });

  $('#blogSearch input[name="q"]').on("keyup", function () {
    var searchKey = $(this).val();
    var searchUrl = "/search?q="+ $(this).val() +"&type=article";
    if($(this).val().length > 2) {
      $("#blogSearch").removeClass('suggestion-active');
      $("#blogSearch").addClass('show-loader');
      jQuery.getJSON("/search/suggest.json", {
        s: $(this).val(),
        resources: {
          types: ["article"],
          limit: 6,
          options: {
            fields: "title,tag,body"
          }
        }
      }).done(function (response) {
        $("#blogSearch").removeClass('show-loader');
        var productSuggestions = response.resources.results.articles;
        var resultHtml = "";
        if (productSuggestions.length > 0) {
          for (var i in productSuggestions) {
            var itemUrl = productSuggestions[i].url.split("?");
            var summary_html = productSuggestions[i].summary_html ? productSuggestions[i].summary_html : productSuggestions[i].body;
            resultHtml +=
              '<div class="item col-md-6 col-12">' +
              '<div class="col-img">' +
              '<a href="' + itemUrl[0] + '" title="' + productSuggestions[i].title + '">'+
              '<img src="' + productSuggestions[i].image + '" alt="' + productSuggestions[i].title + '"/>' +
              '</a>' +
              '</div>' +
              '<div class="article-info">' +
              '<h3 class="article-title">' +
              '<a href="' + itemUrl[0] + '" title="' + productSuggestions[i].title + '">' +
              productSuggestions[i].title +
              '</a>' +
              '</h3>' +
              '<div class="summary-html">' +
              summary_html +
              '</div>' +
              '</div>' +
              '</div>';
          }
          $("#blogSearch .article-suggestions").html(resultHtml);
          $('.summary-html iframe').remove();
          $("#blogSearch").addClass('suggestion-active');
          $("#blogSearch .search-suggestions").stop().slideDown(400, function () {
            $("#blogSearch .search-suggestions").css("height", "");
          });
          //$("#blogSearch .block-footer a").attr("href", searchUrl);
        }
        else{
          $("#blogSearch .article-suggestions").html("");
          $("#blogSearch").removeClass('suggestion-active');
          $("#blogSearch .search-suggestions").stop().slideUp(200, function () {
            $("#blogSearch .search-suggestions").css("height", "");
          });
        }
      });
    }
    else {
      $("#blogSearch").removeClass('suggestion-active');
      $("#blogSearch .search-suggestions").stop().slideUp(200, function () {
        $("#blogSearch .search-suggestions").css("height", "");
      });
    }

    if($(this).val().length > 0) {
      $('#blogSearch').addClass('active');
    }
    else {
      $('#blogSearch').removeClass('active');
    }
  });

  $('#blogSearch .clear').on('click', function() {
    $('#blogSearch input[name="q"]').val('');
    $("#blogSearch").removeClass('suggestion-active');
    $("#blogSearch .search-suggestions").stop().slideUp(200, function () {
      $("#blogSearch .search-suggestions").css("height", "");
    });
    $('#blogSearch').removeClass('active');
  });

  $('.product-articles-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    nextArrow: '<div class="slick-button-next" aria-label="Next">' + theme.assets.icon_right + '</div>',
    prevArrow: '<div class="slick-button-prev" aria-label="Previous">' + theme.assets.icon_left + '</div>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });


  $('.get-quote').on("click", function(e) {
    e.preventDefault();
    $.fancybox.open({
      src  : '#hbspt-form',
      type : 'inline',
      width : '100%',
      opts : {
        afterShow : function( ) {

        }
      }
    });
  });

  $('.newsletter-button').on("click", function(e) {
    e.preventDefault();
    $.fancybox.open({
      src  : '#hbspt-form-subscribe',
      type : 'inline',
      width : '100%',
      opts : {
        afterShow : function( ) {

        }
      }
    });
  });

  $('.form-question-wrap input').on('change', function (e) {
    $('.request-form').toggleClass('active');
    $('.get-quote-form').toggleClass('active');
  })

    $('.home__solution--slider').slick({
        dots: true,
        prevArrow: $('.custom--button-prev'),
        nextArrow: $('.custom--button-next')
    });

  $('.featured_video--slider').slick({
      variableWidth: true,
      infinite: false,
      dots: false
  });

  $('.synchronized-systems-section-slider .products_slider').slick({
      slidesToShow: 4,
      dots: true,
      responsive: [
          {
              breakpoint: 1025,
              settings: {
                  slidesToShow: 2,
                  dots: true
              }
          },
          {
              breakpoint: 569,
              settings: {
                  slidesToShow: 1,
                  dots: true
              }
          }
      ]
  });

    mobileSliders();
    //vimeoVideo();

  if(theme.subscribePopupEnable){
    if (theme.subscribePopup) {
      if(window.location.pathname=='/'){
        openSubscribePopup();
      }
    }else{
      openSubscribePopup();
    }
  }

  function openSubscribePopup(){
    $(window).scroll(function() {
      var win_h = $(window).height();
      if(!getCookie("subscribe-popup")) {
        if (win_h <= $(this).scrollTop()) {
          setCookie("subscribe-popup", true, 1);
          $.fancybox.open({
            src  : '#hbspt-form-subscribe',
            type : 'inline',
            width : '100%',
            height : 'auto',
            opts : {
              afterShow: function () {

              }
            }
          });
        }
      }
    });
  }


    $('.promotions__application--btn').on("click", function(e) {
        e.preventDefault();
        $.fancybox.open({
            src  : '#promotions__application--form',
            type : 'inline',
            width : '100%',
            opts : {
                afterShow : function( ) {

                }
            }
        });
    });

    $(window).resize(function() {
        mobileSliders();
    });

    function mobileSliders() {
        if ($(window).width() <= 575) {
            $('.linear-sol__content').slick({
                dots: true
            });
            $('.home-sol__content-top .justify-content-center').slick({
                dots: true
            });
        } else {
            if ($('.linear-sol__content').hasClass('slick-slider')) {
                $('.linear-sol__content').slick('unslick');
            }
            if ($('.home-sol__mobile_slider').hasClass('slick-slider')) {
                $('.home-sol__mobile_slider').slick('unslick');
            }
        }
    }

  function TotalLength(el){

    var path = document.querySelectorAll(el);
    if($(el).length > 0){
      for (let elem of path) {
        if(elem.getAttribute("stroke-dasharray")){
          var len = Math.round(elem.getTotalLength() );
          elem.setAttribute("stroke-dasharray", len);
          elem.setAttribute("stroke-dashoffset", len);
          elem.classList.add('draw');
        }
      }
    }
  };

   var header_banner = $('.header-banner.with-animation');
    if(header_banner){
      header_banner.find('.z-top__header').css('opacity','1');
      TotalLength('#actuator-with-usp #Oval');
      TotalLength('#actuator-with-usp #Path');
      setTimeout(function() {
        header_banner.find('.z-top__text').css('opacity','1');
        header_banner.find('.header-content-icons-block svg').css('opacity','1');
        header_banner.find('.header-content-icons-block img').css('opacity','1');
        header_banner.find('#logo_actuators_landing').css('opacity','1');
        TotalLength('#actuator-icon-collection path');
        TotalLength('#actuator-icon-collection #Oval');
        TotalLength('#actuator-icon-collection #Path');
      }, 1000);
      setTimeout(function() {
        header_banner.find('.btn').css('opacity','1');
        header_banner.find('.swiper-container').css('opacity','1');
        header_banner.find('.brands-slide').css('opacity','1');
        TotalLength('#actuator-icon path');
        TotalLength('#actuator-icon #Oval');
        TotalLength('#product_icon #Path');
        TotalLength('#product_icon #Oval');
        header_banner.find('.header-content-icons-title').css('opacity','1');
        header_banner.find('.header-svg circle').css('opacity','1');
        header_banner.find('#actuator-with-usp .path-fill').addClass('full');
        header_banner.find('#actuator-with-usp .path-fill-dark').addClass('full');
      }, 2000);
      setTimeout(function() {
        header_banner.find('#actuator-icon .path-fill').addClass('full');
        header_banner.find('#product_icon .path-fill').addClass('full');
        header_banner.find('#product_icon .path-fill-dark').addClass('full');
        header_banner.find('#actuator-with-usp .path-fill-white').addClass('full');
      }, 2600);
    }

  function productsSlider() {
    var slider = $('.products-slider');
    var slidesCount
    var progressBar = $('.progress-bar');
    slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
      progressBar
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc);
    });
    slider.on('init', function (event, slick) {
      slidesCount = slick.slideCount;
      if (slidesCount < 10) {
        $('.count').text('0' + slidesCount);
      } else {
        $('.count').text(slidesCount);
      }
    });
    slider .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true
    });

    $('.project-slider-button[data-slide]').click(function(e) {
      e.preventDefault();
      var slideno = $(this).data('slide');
      $('.products-slider').slick('slickGoTo', slideno - 1);

      var offsetTop;
      if($(window).width() > 1200) {
        offsetTop = $('.section-products').offset().top - $('.topping__line-bottom ').height();
      }else{
        offsetTop = $('.section-products').offset().top - $('.topping.with-sticky').height();
      }
      $('html, body').animate({
        scrollTop: offsetTop
      }, 1000);
    });
  };
  if ($('body').hasClass('local-california')) {
    hideProgress();
  }
  productsSlider();
});

function vimeoVideo() {
    var iframe = $('.section__featured--video iframe');
    if (iframe.val() !== undefined) {
        window.vimeoPlayer = new Vimeo.Player(iframe);
        vimeoPlayer.setVolume(0);
        vimeoPlayer.play();

    }
}